import { cn } from '@/lib/utils';
import { Edit3 } from 'lucide-react';
import { getConsentPillConfig } from './ConsentStatusPill.config';
import {
  decidedLabelledIconClasses,
  decidedLabelledPillClasses,
  decidedLabelledPillInteractiveClasses,
  decidedPillClasses,
  decidedPillInteractiveClasses,
  undecidedPillClasses,
  undecidedPillInteractiveClasses,
} from './ConsentStatusPill.styles';
import type { ConsentStatusPillProps } from './ConsentStatusPill.types';

/**
 * Consent status pill: an icon for active/rejected (labelled with showLabel), a
 * labelled amber pill for not_viewed/error. Rendered inside ConsentAttestControl's button.
 */
export const ConsentStatusPill = ({ status, interactive = false, showLabel = false }: ConsentStatusPillProps) => {
  const config = getConsentPillConfig(status);
  if (!config) return null;

  const Icon = config.icon;
  const isUndecided = status === 'not_viewed' || status === 'error';

  if (isUndecided) {
    return (
      <span className={cn(undecidedPillClasses, interactive && undecidedPillInteractiveClasses)}>
        <Edit3 className="h-3.5 w-3.5" />
        <span>{config.label}</span>
      </span>
    );
  }

  if (showLabel) {
    return (
      <span className={cn(decidedLabelledPillClasses, interactive && decidedLabelledPillInteractiveClasses)}>
        <Icon className={cn(decidedLabelledIconClasses, config.iconClass)} />
        <span>{config.label}</span>
      </span>
    );
  }

  return <Icon className={cn(decidedPillClasses, interactive && decidedPillInteractiveClasses, config.iconClass)} />;
};
